import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.css';

function Privacy() {
  const { t } = useTranslation();
  const points = [
    'Solo usamos tus datos para gestionar tu solicitud de inmigracion.',
    'Nunca vendemos ni compartimos tus datos con terceros.',
    'Tus datos estan cifrados y protegidos.',
    'Puedes solicitar la eliminacion de tus datos en cualquier momento.',
    'Responsable: Global Mobility Group LLC.',
    'Contacto: legal@globalmobility.law.',
  ];

  return (
    <div className="mvp-legal-page">
      <div className="mvp-legal-card">
        <h1>{t('legal.privacy', 'Privacy')}</h1>
        <p className="mvp-legal-placeholder">
          En Global Mobility Group LLC nos tomamos en serio la privacidad de tus datos. Aqui tienes un resumen de como los tratamos:
        </p>
        <ul className="mvp-legal-placeholder">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <p className="mvp-legal-placeholder">
          <a href="https://globalmobility.law/politica-privacidad" target="_blank" rel="noopener noreferrer">
            Ver documento completo
          </a>
        </p>
        <Link to="/" className="mvp-legal-back">{t('legal.goHome', 'Go to home')}</Link>
      </div>
    </div>
  );
}

export default Privacy;
